import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Observable, Observer} from 'rxjs';
import {Config} from './Config';
import {Session} from './Session';

export interface IDistributionImportError {
  row: number;
  field: string;
  value: string;
  message: string;
}

export interface IDistributionImportStatus {
  id: number;
  status: string;
  filename: string;
  rows_count: number;
  rows_processed: number;
  valid_rows: number;
  invalid_rows: number;
  ready_for_import: boolean;
  errors: IDistributionImportError[];
  processed_count: number;
  created_count: number;
  updated_count: number;
  reps_created_count: number;
  failed_count: number;
  dry_run_at?: string;
  executed_at?: string;
  error_message?: string;
}

export interface IDistributionImportUpload {
  id: number;
  rows_count: number;
}

@Injectable()
export class DistributionImport {
  constructor(private http: HttpClient, private config: Config, private session: Session) {}

  uploadFile(filename: string, data): Observable<IDistributionImportUpload> {
    let s = Observable.create((observer: Observer<IDistributionImportUpload>) => {
      let r = new XMLHttpRequest();
      r.open("POST", this.config.apiUrl + '/distribution_import/file/' + encodeURIComponent(filename), true);
      r.setRequestHeader('Authorization', 'Bearer ' + this.session.getToken());
      r.onload = () => {
        if (r.status >= 200 && r.status < 300) {
          try {
            observer.next(JSON.parse(r.responseText));
            observer.complete();
          } catch (e) {
            observer.error(e);
          }
        } else {
          observer.error({status: r.status, error: r.responseText});
        }
      };
      r.onerror = (err) => {
        observer.error(err);
      };
      r.send(data);
    });
    return s;
  }

  dryRun(id: number): Observable<string> {
    let headers = new HttpHeaders();
    headers = headers.append('Content-Type', 'text/json');
    headers = this.session.setAuthHeader(headers);
    return this.http.post(this.config.apiUrl + `/distribution_import/${id}/dry_run`, '', {headers: headers, responseType: 'text'});
  }

  getStatus(id: number): Observable<IDistributionImportStatus> {
    let headers = new HttpHeaders();
    headers = headers.append('Content-Type', 'text/json');
    headers = this.session.setAuthHeader(headers);
    return this.http.get<IDistributionImportStatus>(this.config.apiUrl + `/distribution_import/${id}/status`, {headers: headers});
  }

  execute(id: number): Observable<string> {
    let headers = new HttpHeaders();
    headers = headers.append('Content-Type', 'text/json');
    headers = this.session.setAuthHeader(headers);
    return this.http.post(this.config.apiUrl + `/distribution_import/${id}/execute`, '', {headers: headers, responseType: 'text'});
  }

  reportUrl(id: number): string {
    return this.config.apiUrl + `/distribution_import/report/${id}/${this.session.getToken()}`;
  }
}
